export default __webpack_public_path__ + "static/media/addManageFiles.8e9da94b.png";